import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useFetchWorkOrder } from "../actions/noc-module.actions";
import { OrdenTrabajoNoc } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { useTableColumnsWorkOrder } from "../hooks/useTableColumnsWorkOrder";
import { RemoveRedEye, ReviewsRounded } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared";
import AuditViewModal from "./AuditViewModal";
import { useState } from "react";

export default function TabOrdenTrabajoNocFinalizadas() {

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoEditarPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocNav;

    const { columnsWorkOrder } = useTableColumnsWorkOrder();

    const { pagination, setPagination } = useTableFilter();
    const { pageIndex, pageSize } = pagination;
    const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();

    const {
        isLoading,
        data: workOrderRes,
        isRefetching
    } = useFetchWorkOrder({
        page: pageIndex,
        page_size: pageSize,
        orderStatus: 'FINALIZADO',
        ...filterObject,
    });

    const onEdit = (original: OrdenTrabajoNoc) => {
        navigate(`${returnUrlOrdenTrabajoEditarPage}/ver/${original.workOrderId}`);
    };

    const [openAuditModal, setOpenAuditModal] = useState({
        status: false,
        data: null
    });

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={12}>
                    <GeneralTable<OrdenTrabajoNoc>
                        columns={columnsWorkOrder}
                        data={workOrderRes?.data.content || []}

                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        // // search
                        enableGlobalFilter={false}
                        // onGlobalFilterChange={setGlobalFilter}
                        // // pagination
                        pagination={pagination}
                        onPaging={setPagination}
                        rowCount={workOrderRes?.data?.totalElements}

                        ///* filters - server side
                        enableManualFiltering={true}
                        columnFilters={columnFilters}
                        onColumnFiltersChange={setColumnFilters}
                        enableSorting={false}

                        enableColumnActions={true}
                        positionActionsColumn='first'

                        // // actions
                        actionsColumnSize={120}
                        // crud
                        enableEditing={true}
                        editIcon={<RemoveRedEye />}
                        toolTipTitleEditIcon={"Visualizar"}
                        onEdit={onEdit}

                        showCustomActionBtnSpace={true}
                        customActionBtnSpace={(row) => (
                            <Tooltip title="Ver Auditoria">
                                <IconButton
                                    onClick={() => {
                                        setOpenAuditModal({
                                            status: true,
                                            data: row.auditReview as any
                                        });
                                    }}
                                >
                                    <ReviewsRounded color="primary" />
                                </IconButton>
                            </Tooltip>
                        )}
                        canDelete={false}
                    />
                </Grid>
            </Grid>
            {openAuditModal.status && (
                <AuditViewModal
                    open={openAuditModal.status}
                    setOpen={(status) => setOpenAuditModal({ status, data: openAuditModal.data })}
                    form={openAuditModal.data}
                />
            )}
        </>
    );
}